import { InputNumber } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const formatter = (value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
const parser = (value) => value.replace(/\$\s?|(,*)/g, '');

const DynamicFieldInputNumberPrice = ({ value, onChange, ...props }) => {
  return (
    <InputNumber
      value={value}
      onChange={onChange}
      formatter={formatter}
      parser={parser}
      {...props}
    />
  );
};

DynamicFieldInputNumberPrice.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default memo(DynamicFieldInputNumberPrice);
